// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021034/js/" + chunkId + "." + {"44":"4e40fa87","225":"9563942c","481":"1fa723b9","486":"1aed5ec4","770":"9725837f"}[chunkId] + ".0.8354304924411592.chunk.js";
};